// Presentation for messages whose author account was deleted. The server
// replaces the deleted author's legacy entries with `authorDeleted: true`
// placeholders and marks the conversation `partnerDeleted: true`; canonical
// threads keep the tombstone (`state: "deleted"`) with no author presentation.
export const DELETED_ACCOUNT_NAME = "Deleted account";
export const DELETED_ACCOUNT_MESSAGE = "Message from a deleted account";
export const DELETED_PARTNER_NOTE =
  "This account was deleted. You can keep reading your messages.";

export const isDeletedAuthorMessage = (message) =>
  message?.authorDeleted === true;

// Rebuilds a legacy placeholder from an allowlist so no encrypted, shared,
// item or interactive payload can reach rendering, reply or reaction code.
export function toDeletedAccountPlaceholder(message) {
  return {
    id: message?.id,
    from: message?.from,
    to: message?.to,
    messageTime: message?.messageTime,
    read: message?.read === true,
    authorDeleted: true,
    messageBody: DELETED_ACCOUNT_MESSAGE,
    senderDisplayName: DELETED_ACCOUNT_NAME,
    recipientDisplayName:
      typeof message?.recipientDisplayName === "string"
        ? message.recipientDisplayName
        : "",
  };
}

// Legacy conversation entries: never decrypt a deleted author's placeholder.
export function presentLegacyMessage(message, decrypt) {
  if (isDeletedAuthorMessage(message)) return toDeletedAccountPlaceholder(message);
  return decrypt(message);
}

// Canonical thread tombstones: a deleted message without an author
// presentation belongs to an account that no longer exists.
export const isDeletedAccountTombstone = (message) =>
  message?.state === "deleted" && !message?.author;
